import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Radium, { StyleRoot } from 'radium';
import { injectIntl, intlShape } from 'react-intl';

import * as keyboardEventHelpers from 'globals/keyboardEvents';

import { styles } from './styles';
import messages from './messages';

class Modal extends PureComponent {
  componentDidMount() {
    this.modal = document.createElement('div');
    document.body.appendChild(this.modal);
    this._renderLayer();
    window.addEventListener('keyup', this.handleKeyPress, false);
  }

  componentDidUpdate() {
    this._renderLayer();
  }

  componentWillUnmount() {
    document.body.removeChild(this.modal);
    window.removeEventListener('keyup', this.handleKeyPress, false);
  }

  handleKeyPress = e => {
    const { onClose } = this.props;

    if (keyboardEventHelpers.isEscKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      onClose();
    }
  };

  handleClick = e => {
    const { onClose } = this.props;

    if (this.node.contains(e.target)) {
      return;
    }

    onClose();
  };

  _renderLayer = () => {
    ReactDOM.render(this.renderModal(), this.modal);
  };

  renderModal = () => {
    const { children, intl, onClose } = this.props;

    return (
      <StyleRoot>
        <div
          id="kustomer-modal-container"
          className="kustomer-app-modal"
          style={styles.modalContainer}
          onClick={this.handleClick}
          role="dialog"
          tabIndex="0"
          aria-label={intl.formatMessage(messages.aria_label_modal)}
        >
          <span onClick={onClose} style={styles.close} aria-label={intl.formatMessage(messages.aria_label_modal_close)}>
            &times;
          </span>
          <div style={styles.modalContent}>
            <div ref={node => (this.node = node)}>{children}</div>
          </div>
        </div>
      </StyleRoot>
    );
  };

  render() {
    return null;
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  intl: intlShape.isRequired,
};

Modal.defaultProps = {
  children: undefined,
  onClose: undefined,
};

const componentWithIntl = injectIntl(Modal, { withRef: true });
export default Radium(componentWithIntl);
